
export type AccessLevel = 'top-secret' | 'secret' | 'confidential' | 'restricted' | 'unclassified';

export type HierarchyRole = 
  | 'system-administrator' 
  | 'security-officer' 
  | 'network-administrator' 
  | 'department-manager'
  | 'technician'
  | 'standard-user';

export interface Organization {
  id: string;
  name: string;
  type: 'government' | 'military' | 'corporate' | 'educational' | 'healthcare';
  accessLevel: AccessLevel;
  description?: string;
}

export interface Department {
  id: string;
  name: string;
  organizationId: string;
  accessLevel: AccessLevel;
  description?: string;
}

export interface Location {
  id: string;
  name: string;
  departmentId: string;
  type: 'building' | 'floor' | 'room' | 'area' | 'zone';
  accessLevel: AccessLevel;
  description?: string;
}

export interface DeviceHierarchy {
  organizations: Organization[];
  departments: Department[];
  locations: Location[];
}

// Define which roles can access which classification levels
export const roleAccessMap: Record<HierarchyRole, AccessLevel[]> = {
  'system-administrator': ['top-secret', 'secret', 'confidential', 'restricted', 'unclassified'],
  'security-officer': ['top-secret', 'secret', 'confidential', 'restricted', 'unclassified'],
  'network-administrator': ['secret', 'confidential', 'restricted', 'unclassified'],
  'department-manager': ['confidential', 'restricted', 'unclassified'],
  'technician': ['restricted', 'unclassified'],
  'standard-user': ['unclassified']
};

export const canAccessLevel = (role: HierarchyRole, level: AccessLevel): boolean => {
  return roleAccessMap[role].includes(level);
};

// MAC address utility function to generate formatted MAC addresses
export const generateMacAddress = (id: string): string => {
  // Generate a MAC address format based on device ID for consistency
  return `00:1A:${id.slice(-2)}:${id.slice(-4, -2)}:${id.slice(-6, -4)}:${id.slice(-8, -6)}`.toUpperCase();
};
